export const incomedata = [
  {
    id:"1",
    Reference: "INV849",
    Date: "24 Dec 2024",
    Store: "Electro Mart",
    Category: "Foreign investment",
    Notes: "Categorize income derived",
    Amount: "$200",
    Payment_Method: "Stripe",
  },
  {
    id:"2",
    Reference: "INV848",
    Date: "10 Dec 2024",
    Store: "Quantum Gadgets",
    Category: "Product Export",
    Notes: "Services that have been verified",
    Amount: "$50",
    Payment_Method: "Paypal",
  },
  {
    id:"3",
    Reference: "INV847",
    Date: "27 Nov 2024",
    Store: "Prime Bazaar",
    Category: "Installation",
    Notes: "POS Installation for Store",
    Amount: "$800",
    Payment_Method: "Cash",
  },
  {
    id:"4",
    Reference: "INV846",
    Date: "18 Nov 2024",
    Store: "Gadget World",
    Category: "Product Sales",
    Notes: "Services that have been verified",
    Amount: "$100",
    Payment_Method: "Paypal",
  },
  {
    id:"5",
    Reference: "INV845",
    Date: "06 Nov 2024",
    Store: "Volt Vault",
    Category: "Local Sale",
    Notes: "Travel fare for client meeting",
    Amount: "$700",
    Payment_Method: "Cash",
  },
  {
    id:"6",
    Reference: "INV844",
    Date: "25 Oct 2024",
    Store: "Elite Retail",
    Category: "Service Fees",
    Notes: "Services that have been verified",
    Amount: "$1000",
    Payment_Method: "Cash",
  },
  {
    id:"7",
    Reference: "INV843",
    Date: "14 Oct 2024",
    Store: "Prime Mart",
    Category: "Return/Refund Income",
    Notes: "Flight tickets for meetings",
    Amount: "$1200",
    Payment_Method: "Paypal",
  },
  {
    id:"8",
    Reference: "INV842",
    Date: "03 Oct 2024",
    Store: "NeoTech Store",
    Category: "Foreign investment",
    Notes: "Services that have been verified",
    Amount: "$750",
    Payment_Method: "Stripe",
  },
  {
    id:"9",
    Reference: "INV841",
    Date: "20 Sep 2024",
    Store: "Urban Mart",
    Category: "Product Export",
    Notes: "Categorize income derived in office",
    Amount: "$450",
    Payment_Method: "Stripe",
  },
  {
    id:"10",
    Reference: "INV840",
    Date: "10 Sep 2024",
    Store: "Travel Mart",
    Category: "Return/Refund Income",
    Notes: "Services that have been verified",
    Amount: "$530",
    Payment_Method: "Cash",
  },
];
